import React, { Component } from 'react';
import ReactHtmlParser from 'react-html-parser';
import { isMobile } from "react-device-detect";
import { Link } from 'react-router-dom';
import playIcon from '../../../images/icons/play.svg';
import pauseIcon from '../../../images/icons/pause.svg';
import streamIcon from '../../../images/icons/streaming-white-circle.svg';
import Player from '@vimeo/player';
import './LandingPoster.css';

class LandingPoster extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isVideoPlaying: false,
        }
    }

    componentWillReceiveProps(props) {
        if (props.event.event_type === 'Video On Demand' || props.event.event_type === 'Live Stream' || props.event.event_type === 'Scheduled Content' && props.event.poster_vimeo_video_id) {
            if (props.event.poster_vimeo_video_id) {
                this.player = new Player(`poster-${props.event.id}`, {
                    id: props.event.poster_vimeo_video_id,
                    width: '100%',
                    height: '100%',
                    autoplay: true,
                    muted: false,
                    controls: false,
                    loop: true,
                });

                this.player.pause();
            }
        }
    }

    componentWillUnmount() {
        if (this.player) {
            this.player.destroy()
        }
    }

    playVideo = () => {
        if (!isMobile) {
            if (this.player) {
                this.player.play()
            }
            this.setState({
                isVideoPlaying: true,
            });
        }
    }

    stopVideo = () => {
        if (!isMobile) {
            if (this.player) {
                this.player.pause()
            }
            this.setState({
                isVideoPlaying: false,
            });
        }
    }

    toggleVideo = () => {
        if (isMobile) {
            this.setState({
                isVideoPlaying: !this.state.isVideoPlaying,
            }, () => {
                this.state.isVideoPlaying ? this.player.play() : this.player.pause();
            });
        }
    }

    renderPlayerButton = () => {
        if (this.props.event.event_type === 'Video On Demand' || this.props.event.event_type === 'Live Stream' || this.props.event.event_type === 'Scheduled Content') {
            return (
                <Link
                    to={`/stream/`}
                    className="showtix-event__settings"
                    target="_blank"
                    aria-label="Click here to go to the stream player in a new window"
                >
                    <img
                        src={streamIcon} alt=""
                    />
                </Link>
            );
        } else {
            return null;
        }
    }

    renderVideo = () => {
        if (this.props.event.event_type === 'Video On Demand' || this.props.event.event_type === 'Live Stream' || this.props.event.event_type === 'Scheduled Content') {
            return (
                <div className="showtix-event-landing__poster__video">
                    <div id={`poster-${this.props.event.id}`}></div>
                </div>
            )
        } else {
            return null;
        }
    }

    render() {
        return (
            <div className="">
                <div className={this.state.isVideoPlaying ? `showtix-event-landing__poster is-hover` : `showtix-event-landing__poster`}
                    onMouseOver={() => this.playVideo()}
                    onMouseOut={() => this.stopVideo()}
                >
                    <div className="showtix-event__bar">
                        {this.renderPlayerButton()}
                        {isMobile && (this.props.event.event_type === 'Video On Demand' || this.props.event.event_type === 'Live Stream' || this.props.event.event_type === 'Scheduled Content') && (
                            <button
                                className="showtix-event-landing__poster__trailer"
                                onClick={() => this.toggleVideo()}
                                aria-label="Click here to watch the trailer"
                            >
                                <img
                                    src={this.state.isVideoPlaying ? pauseIcon : playIcon} alt=""
                                />
                            </button>
                        )}
                    </div>
                    { this.props.event.poster_graphic_url ?
                        <img src={this.props.event.poster_graphic_url} className="showtix-event-landing__poster__img" alt="" />
                        :
                        (this.props.event.type === "flexpass" ?
                                <img src={process.env.REACT_APP_PUBLIC_URL + "/images/generic_poster_flex.jpg"} className="showtix-event-landing__poster__img" alt="" />
                                :
                                <img src={process.env.REACT_APP_PUBLIC_URL + "/images/generic_poster_event.jpg"} className="showtix-event-landing__poster__img" alt="" />
                        )
                    }
                    {!this.props.event.poster_graphic_url &&
                    <div className="showtix-event__poster__title">
                        {ReactHtmlParser(this.props.event.name)}
                    </div>
                    }
                    {this.renderVideo()}
                </div>
            </div>
        );
    }
}

LandingPoster.propTypes = {
    
}

export default LandingPoster;


// WEBPACK FOOTER //
// ./src/components/EventLanding/LandingPoster/LandingPoster.js